import React, { useEffect, useState, useCallback } from "react";
import { Grid, Checkbox, Input, Radio, Message } from "semantic-ui-react";
import "../../views/pages/campaigns/New.scss";
import ReactTable from "react-table";
import "react-table/react-table.css";
import NumberFormat from "react-number-format";
import CurrencyInput from "react-currency-input-field";
import { useAuth } from "../../AuthenticationStore";

export const Preview = ({
  cdCampaignConfiguration,
  campaignId,
  onChangeValuesObject,
  errors,
  modification,
  errorsPreview
}) => {
  const { campaignService } = useAuth();
  const typeObjectName = "cdCampaignConfiguration";
  const [totalCustomers, setTotalCustomers] = useState({});
  const [loadingCustomers, setLoadingCustomers] = useState(true);
  const [pagesCustomers, setPagesCustomers] = useState(0);
  const [exceptionInfo, setExceptionInfo] = useState([]);

  const [pageSize, setPageSize] = useState(0);
  const [page, setPage] = useState(5);

  const [projectedAmount, setProjectedAmount] = useState();
  const onChangeProjectedAmount = useCallback(
    (newValue) => setProjectedAmount(newValue),
    [setProjectedAmount]
  );

  const [projectedCustomer, setProjectedCustomer] = useState(0.0);
  const onChangeProjectedCustomer = useCallback(
    ev => setProjectedCustomer(ev.target.value),
    [setProjectedCustomer]
  );

  const [targetAmount, setTargetAmount] = useState(0);

  const [targetCustomer, setTargetCustomer] = useState(0.0);

  const [radioFilterCustomers, setRadioFilterCustomers] = useState("2");
  const handleChangeRadioFilterCustomers = useCallback(
    (_, newValue) => {
      setRadioFilterCustomers(newValue.value);
      fetchData({ page, pageSize, radioFilterCustomers: newValue.value });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [page, pageSize]
  );

  const [data, setData] = useState([]);

  const columns = [
    {
      Header: "Identificación",
      accessor: "id"
    },
    {
      Header: "Email",
      accessor: "email"
    },
    {
      Header: "Celular",
      accessor: "mobile"
    },
    {
      Header: "Nombre",
      accessor: "name"
    },
    {
      Cell: props => (
        <NumberFormat
          className="rt-cell-right"
          value={props.value}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />
      ),
      Header: "Cupo",
      accessor: "creditAmount"
    },
    {
      Cell: props => (
        <NumberFormat
          className="rt-cell-right"
          value={props.value}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />
      ),
      Header: "Capacidad",
      accessor: "capacity"
    },
    {
      Cell: props => <span className="rt-cell-right">{props.value}</span>,
      Header: "Días actualización",
      accessor: "daysLastUpdateInformation"
    },
    {
      Cell: props => <span className="rt-cell-right">{props.value}</span>,
      Header: "Días consulta centrales",
      accessor: "daysLastQueryCentralRisk"
    }
  ];

  const [applyUpdateData, setApplyUpdateData] = useState(false);
  const [applyQueryCentralRisk, setApplyQueryCentralRisk] = useState(false);

  useEffect(() => {
    if (!cdCampaignConfiguration) return;
    setApplyUpdateData(cdCampaignConfiguration.applyUpdateData);
    setApplyQueryCentralRisk(cdCampaignConfiguration.applyQueryCentralRisk);
    setProjectedCustomer(cdCampaignConfiguration.projectedCustomer);
    setTargetCustomer(cdCampaignConfiguration.targetCustomer);

    if (cdCampaignConfiguration.projectedAmount)
      setProjectedAmount(cdCampaignConfiguration.projectedAmount.toString());

    if (cdCampaignConfiguration.targetAmount)
      setTargetAmount(cdCampaignConfiguration.targetAmount.toString());
  }, [cdCampaignConfiguration]);

  const updateValues = useCallback(() => {
    let cdCampaignConfigurationTempData = {
      applyQueryCentralRisk,
      applyUpdateData,
      creationDate: cdCampaignConfiguration.creationDate,
      finishDate: cdCampaignConfiguration.finishDate,
      guarantee: cdCampaignConfiguration.guarantee,
      legalizationForm: cdCampaignConfiguration.legalizationForm,
      loanDestination: cdCampaignConfiguration.loanDestination,
      loanType: cdCampaignConfiguration.loanType,
      name: cdCampaignConfiguration.name,
      nameDestination: cdCampaignConfiguration.nameDestination,
      nameGuarantee: cdCampaignConfiguration.nameGuarantee,
      projectedAmount,
      projectedCustomer,
      startDate: cdCampaignConfiguration.startDate,
      targetAmount,
      targetCustomer
    };

    onChangeValuesObject(typeObjectName, cdCampaignConfigurationTempData);
  }, [
    applyQueryCentralRisk,
    applyUpdateData,
    cdCampaignConfiguration,
    onChangeValuesObject,
    projectedAmount,
    projectedCustomer,
    targetAmount,
    targetCustomer
  ]);

  const handleChangeApplyUpdateData = useCallback(
    (_, newValue) => setApplyUpdateData(newValue.checked),
    [setApplyUpdateData]
  );

  const handleChangeApplyQueryCentralRisk = useCallback(
    async (_, newValue) => setApplyQueryCentralRisk(newValue.checked),
    [setApplyQueryCentralRisk]
  );

  const fetchData = state => {
    setLoadingCustomers(true);
    campaignService
      .getCustomersCampaign(
        campaignId,
        state.page * state.pageSize,
        state.pageSize,
        state.radioFilterCustomers || radioFilterCustomers
      )
      .then(response => {
        setLoadingCustomers(false);

        if (response.object && response.object.campaignCustomers)
          setData(response.object.campaignCustomers);

        if (response.object && response.object.totalCustomers) {
          setTotalCustomers(response.object.totalCustomers);
          setPagesCustomers(
            Math.ceil(
              response.object.totalCustomers.totalCustomer / state.pageSize
            )
          );

          setTargetCustomer(response.object.totalCustomers.totalCustomer);
          setTargetAmount(response.object.totalCustomers.totalAmount);
        }

        setExceptionInfo(
          response.cdExceptions.filter(item => item.severityException === 2)
        );
      })
      .catch();
  };

  const [readOnly, setReadOnly] = useState(false);
  useEffect(() => {
    setReadOnly(modification === false);
  }, [modification]);

  return (
    <Grid>
      <Grid.Row>
        <div className="col-md-1"></div>
        <div className="col-md-6 ">
          <form
            className="ui form tiny preview-launch-form"
            style={{ width: "100%" }}
          >
            <div className="equal width fields preview-tiny-form">
              <div className=" field">
                <label>Potencial</label>
                <div className="ui fluid input "></div>
              </div>
              <div className="field">
                <label>Proyectado</label>
                <div className="ui fluid input"></div>
              </div>
            </div>
            <div className="equal width fields preview-tiny-form">
              <div className=" field">
                <label>Monto</label>
                <div className="ui fluid input ">
                  <NumberFormat
                    readOnly
                    value={totalCustomers.totalAmount || 0}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </div>
              </div>
              <div className="field">
                <label>Monto</label>
                <div className="ui fluid input">
                  <Input>
                    <CurrencyInput
                      readOnly={readOnly}
                      value={projectedAmount}
                      onChange={onChangeProjectedAmount}
                      allowDecimals={true}
                      decimalsLimit={2}
                      onBlur={updateValues}
                    />
                  </Input>
                </div>
              </div>
            </div>
            <div className="equal width fields preview-tiny-form">
              <div className="field">
                <label>Clientes</label>
                <div className="ui fluid input">
                  <Input
                    type="number"
                    readOnly
                    value={totalCustomers.totalCustomer || 0}
                  />
                </div>
              </div>
              <div className="field">
                <label>Clientes</label>
                <div className="ui fluid input">
                  <Input>
                    <input
                      className="ui input"
                      value={projectedCustomer}
                      onChange={onChangeProjectedCustomer}
                      readOnly={readOnly}
                      type="number"
                      onBlur={updateValues}
                    />
                  </Input>
                </div>
              </div>
            </div>
            <div className="equal width fields preview-tiny-form">
              <div className="field">
                <Checkbox
                  size="tiny"
                  checked={applyUpdateData}
                  toggle
                  disabled={readOnly}
                  label="Aplica política de actualización de datos"
                  onChange={handleChangeApplyUpdateData}
                  onBlur={() => updateValues()}
                />
              </div>
            </div>
            <div className="equal width fields preview-tiny-form">
              <div className="field">
                <Checkbox
                  checked={applyQueryCentralRisk}
                  toggle
                  disabled={readOnly}
                  label="Aplica política de consulta centrales de información"
                  onChange={handleChangeApplyQueryCentralRisk}
                  onBlur={() => updateValues()}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-2"></div>
        <div className="col-md-2">
          <div className="card bg-success col-md-12 card-preview-total">
            <div
              className="card-body card-body-preview-total"
              style={{ textAlign: "right" }}
            >
              <h4 style={{ marginBottom: "3px" }}>
                <i className="fa fa-tag"></i> Clientes potenciales
              </h4>
              <i className="fa fa-money"></i>{" "}
              <NumberFormat
                value={
                  totalCustomers.totalAmount ? totalCustomers.totalAmount : 0
                }
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
              <br />
              <i className="fa fa-users"></i>{" "}
              <NumberFormat
                type="number"
                displayType={"text"}
                value={totalCustomers.totalCustomer || 0}
              />
            </div>
          </div>
          <div className="card bg-warning col-md-12 card-preview-total">
            <div
              className="card-body card-body-preview-total"
              style={{ textAlign: "right" }}
            >
              <h4 style={{ marginBottom: "3px" }}>
                <i className="fa fa-tags"></i> Inhabil actualización
              </h4>
              <NumberFormat
                value={
                  totalCustomers.totalNotGoodInformationAmount
                    ? totalCustomers.totalNotGoodInformationAmount
                    : 0
                }
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />{" "}
              <i className="fa fa-money"></i>
              <br />
              <NumberFormat
                type="number"
                displayType={"text"}
                value={totalCustomers.totalNotGoodInformationCustomer || 0}
              />{" "}
              <i className="fa fa-users"></i>
            </div>
          </div>
          <div className="card bg-danger col-md-12 card-preview-total">
            <div
              className="card-body card-body-preview-total"
              style={{ textAlign: "right" }}
            >
              <h4 style={{ marginBottom: "3px" }}>
                <i className="fa fa-tag"></i> Inhabil central
              </h4>
              <i className="fa fa-money"></i>{" "}
              <NumberFormat
                value={
                  totalCustomers.totalNotGoodCentralRiskAmount
                    ? totalCustomers.totalNotGoodCentralRiskAmount
                    : 0
                }
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
              <br />
              <i className="fa fa-users"></i>{" "}
              <NumberFormat
                type="number"
                displayType={"text"}
                value={totalCustomers.totalNotGoodCentralRiskCustomer || 0}
              />
            </div>
          </div>
        </div>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={16}>
          {exceptionInfo.map((item, key) => (
            <Message info key={key}>
              <p>{item.exception}</p>
            </Message>
          ))}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className="filter-preview-table">
        <div className="col-md-1"></div>
        <div className="col-md-3">
          <Radio
            label="Clientes hábiles"
            className="campaign-new__preview_checkbox"
            toggle
            value="2"
            checked={radioFilterCustomers === "2"}
            onChange={handleChangeRadioFilterCustomers}
            name="radioFilterCustomers"
          />
        </div>
        <div className="col-md-3">
          <Checkbox
            className="campaign-new__preview_checkbox"
            toggle
            name="radioFilterCustomers"
            value="0"
            checked={radioFilterCustomers === "0"}
            onChange={handleChangeRadioFilterCustomers}
            label="Inhábiles por consulta centrales información"
          />
        </div>
        <div className="col-md-3">
          <Checkbox
            className="campaign-new__preview_checkbox"
            toggle
            name="radioFilterCustomers"
            value="1"
            checked={radioFilterCustomers === "1"}
            onChange={handleChangeRadioFilterCustomers}
            label="Inhábiles por actualización de datos"
          />
        </div>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <ReactTable
            ref={instance => {
              if (!instance) return;
              setPageSize(instance.state.pageSize);
              setPage(instance.state.page);
            }}
            manual
            defaultPageSize={10}
            data={data}
            loading={loadingCustomers}
            onFetchData={fetchData}
            pages={pagesCustomers}
            minRows={1}
            columns={columns}
            previousText="Anterior"
            nextText="Siguiente"
            pageText="Página"
            ofText="de"
            rowsText="registros"
            defaultFilterMethod={(filter, row) =>
              row[filter.id].startsWith(filter.value) ||
              row[filter.id].endsWith(filter.value)
            }
          />
        </Grid.Column>
      </Grid.Row>
      {errorsPreview.length > 0 ? (
        <Grid.Row>
          <Grid.Column>
            <Message negative="Error" list={errorsPreview} />
          </Grid.Column>
        </Grid.Row>
      ) : null}

      {errors.field ? (
        <Grid.Row>
          <Grid.Column>
            <Message negative>
              <Message.Header>Error</Message.Header>
              <p>{errors.exception}</p>
            </Message>
          </Grid.Column>
        </Grid.Row>
      ) : null}
    </Grid>
  );
};

Preview.defaultProps = {
  errors: []
};
